// wrappers for segment functions
import store from 'store/index';
import { getCurrentUser } from 'selectors';
import { DEFAULT_PROPERTIES } from 'analytics/constants';
import getPortalTaskFromPath from 'analytics/helpers';
import { CUSTOMER_PORTAL } from './constants';

export default (eventName, properties, options, callback) => {
  const state = store.getState();
  const { id } = getCurrentUser(state);
  const portalTask = getPortalTaskFromPath(document.location.pathname);
  window.analytics.track(eventName, {
    [portalTask]: JSON.stringify(properties),
    [DEFAULT_PROPERTIES.PORTAL_TASK]: portalTask,
    [DEFAULT_PROPERTIES.USER_ID]: id,
    surface: CUSTOMER_PORTAL
  }, options, callback);
};
